import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { DANS_DISCORD } from '../api/client';

// laravel-echo va chercher Pusher sur l'objet global.
window.Pusher = Pusher;

/**
 * Le lien temps réel avec Reverb.
 *
 * Deux chemins, comme pour l'API : dans Discord tout passe par le proxy
 * (`/.proxy/ws`, réécrit vers `backend.popmovie.fr/app/…` d'après les URL
 * Mappings) ; au navigateur on parle au serveur directement — un WebSocket
 * n'est pas soumis au CORS, donc rien à contourner.
 *
 * L'instance du site (`src/services/echo.js`) n'était pas réutilisable : son
 * hôte y est écrit en dur, et le modifier aurait touché au site pour les
 * besoins de l'Activity.
 */

const CLE = import.meta.env.VITE_REVERB_APP_KEY;

let instance = null;

export function obtenirEcho() {
  if (instance) return instance;

  instance = new Echo({
    broadcaster: 'reverb',
    key: CLE,
    wsHost: DANS_DISCORD ? window.location.hostname : 'backend.popmovie.fr',
    wsPath: DANS_DISCORD ? '/.proxy/ws' : '',
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
  });

  return instance;
}
